var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.cdlass,attrs:{"title":_vm.state}},[_vm._v(" "+_vm._s(_vm.label !== undefined ? _vm.label : _vm.state)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }